/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountPlatformKeyValues {
    getFixupPrototypeFunction() { return ServiceAccountPlatformKeyValues.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountPlatformKeyValues>): ServiceAccountPlatformKeyValues {
        let obj = Object.assign(new ServiceAccountPlatformKeyValues(), model);
        ServiceAccountPlatformKeyValues.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountPlatformKeyValues>): ServiceAccountPlatformKeyValues {
        if (!model) return null;
        return ServiceAccountPlatformKeyValues.newInstance(<ServiceAccountPlatformKeyValues> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountPlatformKeyValues) {
        if (!obj) return;

        models.ServiceAccountPlatformKeyValues.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountPlatformKeyValues): boolean {
        Object.setPrototypeOf(obj, ServiceAccountPlatformKeyValues.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.values_by_key) {
            for (let val of this.values_by_key) {
                models.PlatformKeyValues.fixupPrototype(val);
            }
        }
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * List of platform tag key/value pairs for an account
     */
    values_by_key: Array<models.PlatformKeyValues>;

}
